export default __webpack_public_path__ + "static/media/teamdashboard.67e35c56.png";